<template>
  <div class="reviews">
    <span class="reviews__label">
      Ваши отзывы помогут нам&nbsp;стать лучше
    </span>
    <p class="reviews__text">
      Если при использовании МТС&nbsp;Линк у&nbsp;вас остались нерешенные
      вопросы или&nbsp;пожелания, напишите директору
    </p>
    <div class="reviews__link" @click="copyText(email)">
      <div class="reviews__icon">
        <transition name="fade">
          <VIconMTS
            v-if="isActive"
            key="success"
            name="faq_and_support/icon-success"
            width="32"
            height="32"
          />
          <VIconMTS
            v-else
            key="copy"
            name="faq_and_support/icon-copy"
            width="32"
            height="32"
          />
        </transition>
      </div>
      <transition mode="out-in" name="fade-fast">
        <span v-if="isActive" key="success">Почта скопирована</span>
        <span v-else key="copy">{{ email }}</span>
      </transition>
    </div>
  </div>
</template>

<script>
import VIconMTS from '@/components/Common/MTS/VIconMTS.vue'
import FaqAndSupportContactsMixin from '@/components/Desktop/FaqAndSupport/mixins/FaqAndSupportContactsMixin'

export default {
  name: 'FaqAndSupportReviews',
  components: {
    VIconMTS,
  },
  mixins: [FaqAndSupportContactsMixin],
  data() {
    return {
      email: 'ceo@mts-link.ru',
    }
  },
}
</script>

<style scoped lang="scss">
.reviews {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  padding: 32px;
  margin-top: 88px;
  border-radius: 24px;
  background: $color-white;
  font-size: 24px;
  line-height: 32px;

  @include screen-down('md') {
    margin-top: 32px;
  }

  &__label {
    font-size: 20px;
    line-height: 28px;
    color: $color-gray-1;
  }

  &__text {
    max-width: 791px;
    margin: 8px 0 16px;

    @include screen-down('lg') {
      max-width: 624px;
    }
  }

  &__link {
    display: inline-flex;
    align-items: center;
    gap: 16px;
    cursor: pointer;
  }

  &__icon {
    position: relative;
    width: 44px;
    height: 44px;
    border-radius: 8px;
    background: $color-light;

    svg {
      position: absolute;
      inset: 0;
      margin: auto;
    }
  }
}

.fade-fast-enter-active,
.fade-fast-leave-active {
  transition: opacity 0.2s;
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.4s;
}

.fade-enter,
.fade-leave-to,
.fade-fast-enter,
.fade-fast-leave-to {
  opacity: 0;
}
</style>
